<template>

    <div class="nav-item-profile">
        <button class="btn mb-2 pointer d-md-none d-sm-block b-orange" @click="displayMenu">
            <i class="fas fa-bars p-1" aria-hidden="true">
            </i>
            <span class="ml-2">Menu</span>
        </button>
        <b-nav vertical class="w-100" id="navbar-profile">
            <h5 class="font-gray-dark p-1 mb-2">
                Publicar Curso
            </h5>

            <!--EditElement -->
            <div v-if="curseParent.id">
                <CurseNavBar :curseParent="curseParent" v-if="curseParent.id"/>
                <b-nav-item to="/curse/generate">
                    <i class="fas fa-info-circle"></i>
                    Introducción
                </b-nav-item>
                <b-nav-item v-intro="introTexts.curso_detalle"
                            v-intro-position="'right'"
                            :to="'/curse/generate/' + curseParent.id + '/name'">
                    <i class="fas fa-pen"></i> Detalles
                    del
                    curso
                </b-nav-item>
                <b-nav-item v-intro="introTexts.curso_contenido"
                            v-intro-position="'right'"
                            :to="'/curse/generate/' + curseParent.id + '/content' ">
                    <i class="fas fa-video"></i>
                    Contenido del curso
                </b-nav-item>
                <b-nav-item v-intro="introTexts.curso_publicacion"
                            v-intro-position="'right'"
                            :to="'/curse/generate/' + curseParent.id + '/publish'">
                    <i class="fas fa-bullhorn"></i>
                    Publicación
                </b-nav-item>
            </div>
            <!--NewElement-->
            <div v-else>
                <b-nav-item to="/curse/generate">
                    <i class="fas fa-info-circle"></i>
                    Introducción
                </b-nav-item>
                <b-nav-item
                        v-intro="introTexts.curso_detalle"
                        v-intro-position="'right'" to="/curse/generate/name">
                    <i class="fas fa-pen"></i> {{ curseParent.id ? 'Detalle de curso' : 'Crear curso' }}
                </b-nav-item>

                <b-nav-item v-show="displayButtons"
                            v-intro="introTexts.curso_contenido"
                            v-intro-position="'right'"
                            @click="noDisplay">
                    <i class="fas fa-video"></i> Contenido del curso
                </b-nav-item>
                <b-nav-item v-show="displayButtons"
                            v-intro="introTexts.curso_publicacion"
                            v-intro-position="'right'"
                            @click="noDisplay">
                    <i class="fas fa-bullhorn"></i> Publicación
                </b-nav-item>
            </div>
            <b-dropdown-divider></b-dropdown-divider>
            <b-nav-item to="/perfil/cursos">
                <i class="fas fa-home"></i>
                Volver a cursos
            </b-nav-item>
        </b-nav>
    </div>

</template>
<script>
import CurseNavBar from './CurseNavBar'
import $ from "jquery";

export default {
    name: 'NavBarCurse',
    props: {
        curseParent: Object
    },
    components: {
        'CurseNavBar': CurseNavBar
    },
    data() {
        return {
            showIntro: false,
            introTexts: {
                curso_detalle: "Aquí deberás agregar la descripción y detalles del curso",
                curso_contenido: "En esta sección podrás agregar el contenido del curso",
                curso_publicacion: "Esta es la sección donde podrás publicar tu curso. ¡No olvides dar clic en “Publicar curso” una vez que esté listo! ",
            },
            displayButtons: false,
        }
    },
    created() {
        this.bus.$on('display-courses-intro', v => {
            var intro_ = this.$intro().setOptions({
                            nextLabel: 'Siguiente',
                            prevLabel: 'Anterior',
                            doneLabel: 'Hecho',
                            skipLabel:'Cancelar'})
                            
            this.displayButtons = true
            intro_.onexit(() => {
                this.displayButtons = false
            })
            intro_.start();
        })
    },
    methods: {
        displayMenu() {
            let navbar = $('#navbar-profile')
            if (navbar.hasClass('d-none')) {
                navbar.removeClass('d-none')
                $('ul.nav').addClass('navbar-responsive-active')
            } else {
                $('ul.nav').removeClass('navbar-responsive-active')
                navbar.addClass('d-none')
            }
        },
        noDisplay() {
            swal('Es necesario ingresar la información del curso')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/curses/components/NavBarCurse.vue